import React, {
    useState,
    useEffect,

} from "react"
import { Typography } from './ot'

const BaseCardView1_7 = ({
    mt = 0,
    leading,
    style,
    children,
    className = "",
    props
}, ref) => {


    return (
        <div
            style={style}
            {...props}
            className={`${className} ${props?.className || ""} mt-${mt || 0} leading-${leading || 1}`.trim()}
        >
            {children}
        </div>
    )
}

export default BaseCardView1_7
